import { makeStyles } from '@material-ui/core'
import { loginBackground } from 'src/assets/png'

export const useStyles = makeStyles((theme) => ({
  confirmEmailContainer: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.app.spacing.base,
    alignItems: 'stretch',
    color: '#FFF',
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), ${theme.palette.primary.main}`,
    padding: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 0,
      justifyContent: 'center',
      alignItems: 'center',
      background: '#301e1a'
    },

    '& .confirm-email__button': {
      height: 56,
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 500,
      color: '#FFFFFF',
      width: '100%',
      border: 'none',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 2px 8px rgba(120, 74, 66, 0.15)',
      borderRadius: theme.app.borderRadius.lg,
      cursor: 'pointer',
      textAlign: 'center',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#6a3f38'
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed'
      }
    }
  },

  confirmEmailForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '40px 60px',
    gap: theme.app.spacing.xl,
    flex: 1,
    minWidth: 0,
    maxWidth: 732,
    height: '100vh',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 'unset',
      padding: 30,
      gap: theme.app.spacing.xl,
      height: 'auto'
    }
  },

  confirmEmailImageSide: {
    width: 708,
    height: '100vh',
    backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${loginBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },

  confirmEmailTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 532,
    '& h1': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: 28,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0
    }
  },

  confirmEmailInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.app.spacing.md,
    width: '100%',
    maxWidth: 532,
    '& h2': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: theme.app.typography.h2.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0,
      width: '100%'
    }
  },

  confirmEmailDescription: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 15,
    lineHeight: '150%',
    color: 'rgba(250, 250, 250, 0.85)',
    margin: 0
  },

  confirmEmailEmail: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: theme.app.typography.label.fontSize,
    lineHeight: '150%',
    color: 'rgba(250, 250, 250, 0.7)',
    margin: 0,
    '& strong': {
      color: '#dea169',
      fontWeight: 600
    }
  },

  confirmEmailCodeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.app.spacing.base,
    width: '100%',
    '& label': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.label.fontSize,
      fontWeight: 500,
      color: theme.app.colors.text.light,
      lineHeight: '150%'
    }
  },

  confirmEmailResend: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.app.spacing.sm
  },

  confirmEmailResendButton: {
    background: 'none',
    border: 'none',
    color: '#dea169',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 500,
    cursor: 'pointer',
    textDecoration: 'underline',
    transition: 'all 0.2s',
    '&:hover': {
      color: '#f0b87a'
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed'
    }
  },

  confirmEmailButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.app.spacing.md,
    width: '100%',
    marginTop: 20
  },

  confirmEmailSkipButton: {
    height: 48,
    fontSize: 15,
    fontWeight: 500,
    fontFamily: theme.app.typography.fontFamily.main,
    color: 'rgba(250, 250, 250, 0.7)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
    transition: 'all 0.2s',
    '&:hover': {
      color: theme.app.colors.text.light
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed'
    }
  }
}))
